import React from 'react';
import { Snackbar, Alert } from '@mui/material';

function Notification({ onlineUsers, error, status }) {
  const [open, setOpen] = React.useState(true); // Notification is always open initially

  // Determine the message to display
  let message = '';
  let severity = 'info';

  if (error) {
    message = error;
    severity = 'error';
  } else if (status === 'connected') {
    message = `Online Users: ${onlineUsers}`;
    severity = 'success';
  } else if (status === 'reconnecting') {
    message = 'Reconnecting...';
    severity = 'warning';
  } else if (status === 'failed') {
    message = 'Connection failed. Please refresh the page.';
    severity = 'error';
  }

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Position at bottom-right
      onClose={() => setOpen(false)} // Close only when the user interacts
    >
      <Alert
        onClose={() => setOpen(false)} // Allow manual close
        severity={severity}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default Notification;